import React from "react";
import "./Divider.scss";
const Divider = () => {
  return <div className="divider m-2"></div>;
};

export default Divider;
